import React from 'react';

/**
 * The Modernist micro-label: monospace, 12px, 0.12em tracking, uppercase.
 *
 * Used for every kicker, stat caption and footer line on the page.
 *
 * @param {Object} props
 * @param {'muted'|'ink'|'accent'} [props.tone='muted']
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
function MicroLabel({ tone = 'muted', className = '', children, ...rest }) {
  const toneClass = tone === 'muted' ? '' : `story-micro-${tone}`;

  return (
    <div className={`story-micro ${toneClass} ${className}`.trim()} {...rest}>
      {children}
    </div>
  );
}

export default MicroLabel;
